import React from 'react';
import styled, { StyledComponent } from 'styled-components';
import * as styles from './styles';
import Title from '../../components/title/Title';
import Popup from '../../../ui/popup/Popup';

interface SMSLinkModalProps {
  link: string;
  className?: string;
  lastPhoneNumbers?: string;
  onClose: VoidFunction;
  handleSendAgainLink: VoidFunction;
  sendAgainCountDown: number;
}

export const SMSLinkModal: StyledComponent<React.FC<SMSLinkModalProps>, {}> = styled(({ className, link, handleSendAgainLink, lastPhoneNumbers, onClose, sendAgainCountDown }: SMSLinkModalProps) => {
  const [countDown, setCountDown] = React.useState(sendAgainCountDown);
  React.useEffect(() => {
    const interval = setInterval(() => {
      setCountDown((prev) => (prev ? prev - 1 : prev));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const getCountDownDisplay = () => {
    return countDown <= 9 ? `0${countDown}` : countDown;
  };

  const onLinkAgain = () => {
    setCountDown(sendAgainCountDown);
    handleSendAgainLink();
  };

  return (
    <Popup onClose={onClose} className={className}>
      <Title data-at={'sms-link-modal-title'} className={'modal-title'}>{`Follow the link sent to your phone number ending in ${lastPhoneNumbers}`}</Title>
      <div className={'modal-body'}>
        <div data-at={'sms-link-modal-subtitle'} className={'modal-sub-title'}>
          It may take up to 60 seconds for the link to arrive.
        </div>
        <div className={'resend-link'}>
          <div className={'resend-link-text'}>Didn’t get a link?</div>
          <button onClick={onLinkAgain} data-at={'sms-link-modal-send-again'} disabled={!!countDown} className={`send-again-button`}>
            Send again <span className={'resend-timer'}> {`${countDown ? `0:${getCountDownDisplay()}` : ''}`}</span>
          </button>
        </div>
      </div>
    </Popup>
  );
})`
  ${styles.SMSModalLink}
`;
